import dayjs from 'dayjs'

// assumes dates are already in local timezone
const getNextAppointments = (slots = [], qty = 1, includePastToMatchQty = false) => {
  if(slots === null || slots === undefined || slots.length === 0) {
    return null
  }

  const now = dayjs()
  const sortedSlots = [...slots].sort((a, b) => dayjs(a.starts_at).diff(dayjs(b.starts_at)))
  const futureAppointments = sortedSlots.filter((slot) => slot.starts_at.isSameOrAfter(now) || slot.ends_at.isAfter(now)) // or current 
  
  if (futureAppointments.length === 0 && !includePastToMatchQty) return null

  if (includePastToMatchQty && futureAppointments.length < qty) {
    return sortedSlots.slice(-qty)
  }

  return qty === 1 ? futureAppointments[0] : futureAppointments.slice(0, qty)
}

export default getNextAppointments
